export default {
  'title': '员工管理',
  'add': '添加员工',
  'list.username': '用户名',
  'list.email': '邮箱',
  'list.role': '角色',
  'list.actions': '操作',
  'list.edit': '编辑',
  'list.delete': '删除',
  'list.fetchFailed': '获取员工列表失败',
  'delete.confirm': '确认删除',
  'delete.content': '确定要删除此员工吗？该操作不可撤销。',
  'delete.success': '删除成功',
  'delete.failed': '删除失败',
  'add.title': '添加员工',
  'edit.title': '编辑员工',
  'add.success': '添加成功',
  'add.failed': '添加失败',
  'edit.success': '更新成功',
  'edit.failed': '更新失败',
  'role.admin': '管理员',
  'role.staff': '员工',
  'tabs.basic': '基本信息',
  'tabs.permissions': '权限设置',
  'form.username': '用户名',
  'form.username.required': '请输入用户名',
  'form.email': '邮箱',
  'form.email.required': '请输入邮箱',
  'form.email.invalid': '邮箱格式不正确',
  'form.password': '密码',
  'form.password.required': '请输入密码',
  'form.role': '角色',
  'form.role.required': '请选择角色',
  'form.assignedStore': '分配门店',
  'form.permissionStore': '选择权限门店',
  'form.permissionStore.placeholder': '请选择要设置权限的门店',
  'form.permissionStore.all': '所有门店',
  'form.permissionStore.hint': '不同门店可以设置不同的权限，选择门店后设置权限将只影响该门店',
  'stores.fetchFailed': '获取门店列表失败',
  'permissions.dashboard': '仪表盘',
  'permissions.members': '会员管理',
  'permissions.members.view': '查看会员',
  'permissions.members.create': '创建会员',
  'permissions.members.edit': '编辑会员',
  'permissions.members.delete': '删除会员',
  'permissions.members.export': '导出会员',
  'permissions.cards': '礼品卡管理',
  'permissions.cards.view': '查看礼品卡',
  'permissions.cards.create': '创建礼品卡',
  'permissions.cards.edit': '编辑礼品卡',
  'permissions.cards.delete': '删除礼品卡',
  'permissions.cards.export': '导出礼品卡',
  'permissions.vouchers': '代金券管理',
  'permissions.vouchers.view': '查看代金券',
  'permissions.vouchers.create': '创建代金券',
  'permissions.vouchers.edit': '编辑代金券',
  'permissions.vouchers.delete': '删除代金券',
  'permissions.vouchers.export': '导出代金券',
  'permissions.selectAll': '全选',
  'permissions.hint': '选择主模块会自动选择其所有子权限',
  'permissions.fetchFailed': '获取权限数据失败',
  'staff.title': '员工管理',
  'staff.add': '添加员工',
  'staff.search': '搜索员工',
  'staff.list.id': 'ID',
  'staff.list.username': '用户名',
  'staff.list.email': '邮箱',
  'staff.list.role': '角色',
  'staff.list.stores': '所属门店',
  'staff.list.noStore': '无门店',
  'staff.list.actions': '操作',
  'staff.list.fetchFailed': '获取员工列表失败',
  'staff.list.edit': '编辑',
  'staff.list.delete': '删除',
  'staff.list.empty': '暂无员工数据',
  'staff.list.pagination.total': '共 {total} 条记录',
  'staff.form.username': '用户名',
  'staff.form.email': '邮箱',
  'staff.form.password': '密码',
  'staff.form.role': '角色',
  'staff.form.permissionStore': '权限门店',
  'staff.form.permissionStore.placeholder': '请选择门店',
  'staff.form.permissionStore.all': '所有门店',
  'staff.form.permissionStore.hint': '选择要分配权限的门店',
  'staff.form.permissionStore.selected': '已选门店',
  'staff.form.permissionStore.setting': '{storeName} 权限设置',
  'staff.form.username.required': '请输入用户名',
  'staff.form.email.required': '请输入邮箱',
  'staff.form.email.invalid': '邮箱格式不正确',
  'staff.form.password.required': '请输入密码',
  'staff.form.role.required': '请选择角色',
  'staff.add.success': '添加员工成功',
  'staff.add.failed': '添加员工失败',
  'staff.edit.success': '编辑员工成功',
  'staff.edit.failed': '编辑员工失败',
  'staff.delete.confirm': '确定要删除此员工吗？',
  'staff.delete.content': '确定要删除此员工吗？该操作不可撤销。',
  'staff.delete.success': '删除员工成功',
  'staff.delete.failed': '删除员工失败',
  'staff.tabs.basic': '基本信息',
  'staff.tabs.permissions': '权限设置',
  'staff.add.title': '添加员工',
  'staff.edit.title': '编辑员工',
  'staff.permissions.fetchFailed': '获取权限失败',
  'staff.permissions.selectAll': '全选',
  'staff.permissions.members': '会员管理',
  'staff.permissions.members.view': '查看会员',
  'staff.permissions.members.create': '创建会员',
  'staff.permissions.members.edit': '编辑会员',
  'staff.permissions.members.delete': '删除会员',
  'staff.permissions.members.export': '导出会员',
  'staff.permissions.cards': '礼品卡管理',
  'staff.permissions.cards.view': '查看礼品卡',
  'staff.permissions.cards.create': '创建礼品卡',
  'staff.permissions.cards.edit': '编辑礼品卡',
  'staff.permissions.cards.delete': '删除礼品卡',
  'staff.permissions.cards.export': '导出礼品卡',
  'staff.permissions.vouchers': '优惠券管理',
  'staff.permissions.vouchers.view': '查看优惠券',
  'staff.permissions.vouchers.create': '创建优惠券',
  'staff.permissions.vouchers.edit': '编辑优惠券',
  'staff.permissions.vouchers.delete': '删除优惠券',
  'staff.permissions.vouchers.export': '导出优惠券',
  'staff.permissions.hint': '权限将应用于选定的门店',
  'staff.permissions.clickStore': '请点击门店标签以设置权限',
  'staff.permissions.noStoreSelected': '请先选择门店',
  'staff.permissions.saveFailed': '保存权限失败',
  'staff.permissions.partialSaveError': '部分门店权限保存失败，请稍后重试',
  'staff.permissions.emptyPermissions': '门店 {stores} 没有设置任何权限，请至少添加一个权限',
  'staff.role.admin': '管理员',
  'staff.role.staff': '员工',
  'staff.role.manager': '店长',
  'staff.form.resetPassword': '重置密码',
  'staff.form.resetPassword.hint': '提交后将重置该用户密码',
  'staff.form.newPassword': '新密码',
  'staff.form.newPassword.required': '请输入新密码',
  'staff.password.reset.success': '密码重置成功',
  'staff.password.reset.failed': '密码重置失败',
  'table.sort.desc': '点击降序',
  'table.sort.asc': '点击升序',
  'table.sort.cancel': '取消排序',
}; 